var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconYandexWallet = function SvgIconYandexWallet(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "main",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.682C0 7.37 1.098 6.565 1.098 6.565L9.692 0V7.412H14V18H1.292C0.0219998 18 0 16.73 0 16.73V8.681V8.682Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67701 6.67007C7.28001 6.41607 7.75401 6.67007 7.75401 7.26407C7.75401 7.85607 7.28001 8.53407 6.67701 8.80907C6.07401 9.06407 5.60001 8.80907 5.60001 8.21607C5.60001 7.60207 6.07401 6.92507 6.67701 6.67107V6.67007Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69199 7.41211H11.846V13.7651L1.72299 16.9401L9.69299 11.6461V7.41211H9.69199Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconYandexWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-yandex-wallet.81a15eb8.svg";
export { ForwardRef as ReactComponent };